class DiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'discount_popup_submitted';
  }

  connectedCallback() {
    this.dialogComponent = this.querySelector('dialog-component');
    this.formState = this.querySelector('.discount-popup__form-state');
    this.successState = this.querySelector('.discount-popup__success-state');
    this.form = this.querySelector('.discount-popup__form');
    this.errorEl = this.querySelector('.discount-popup__error');
    this.copyBtn = this.querySelector('.discount-popup__copy-btn');
    this.couponCodeEl = this.querySelector('.discount-popup__code-text');
    this.codeBox = this.querySelector('.discount-popup__code-box');

    // Button is type="button" — the form can NEVER submit natively
    var submitBtn = this.querySelector('[data-submit-btn]');
    if (submitBtn) {
      submitBtn.addEventListener('click', () => this.handleSubmit());
    }

    // Also block any accidental form submission (belt and suspenders)
    if (this.form) {
      this.form.addEventListener('submit', function(e) { e.preventDefault(); });
    }

    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleCopy();
      });
    }

    if (this.codeBox) {
      this.codeBox.addEventListener('click', () => this.handleCopy());
    }

    document.addEventListener('discount-popup:open', () => this.openPopup());
  }

  openPopup() {
    if (!this.dialogComponent) return;

    if (this.hasSubmitted()) {
      this.showSuccess();
    } else {
      this.showForm();
    }

    this.dialogComponent.showDialog();
  }

  showForm() {
    if (this.formState) this.formState.style.display = '';
    if (this.successState) this.successState.style.display = 'none';
    if (this.errorEl) this.errorEl.style.display = 'none';
  }

  showSuccess() {
    if (this.formState) this.formState.style.display = 'none';
    if (this.successState) this.successState.style.display = '';
  }

  hasSubmitted() {
    try {
      return localStorage.getItem(this.STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  markSubmitted() {
    try {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    } catch (e) {}
  }

  async handleSubmit() {
    var emailInput = this.form ? this.form.querySelector('input[type="email"]') : null;
    var email = emailInput ? emailInput.value.trim() : '';

    if (!email) {
      this.showError('Please enter your email address.');
      if (emailInput) emailInput.focus();
      return;
    }

    // Basic email format check
    if (email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      this.showError('Please enter a valid email address.');
      if (emailInput) emailInput.focus();
      return;
    }

    var submitBtn = this.querySelector('[data-submit-btn]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    try {
      var formData = new FormData(this.form);

      await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    } catch (e) {
      // Network error — still show coupon
    }

    // Always show coupon and mark submitted — even if Shopify returns
    // a duplicate error, the user deserves to see the code
    this.markSubmitted();
    this.showSuccess();

    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Get My Code';
    }
  }

  showError(msg) {
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.style.display = '';
    }
  }

  async handleCopy() {
    if (!this.couponCodeEl) return;
    var code = this.couponCodeEl.textContent.trim();

    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }

    var tapHint = this.querySelector('.discount-popup__tap-hint');
    if (tapHint) {
      var orig = tapHint.textContent;
      tapHint.textContent = 'Copied!';
      tapHint.style.color = '#045931';
      tapHint.style.fontWeight = '600';
      setTimeout(function() {
        tapHint.textContent = orig;
        tapHint.style.color = '';
        tapHint.style.fontWeight = '';
      }, 2000);
    }

    var copiedMsg = this.querySelector('.discount-popup__copied');
    if (copiedMsg) {
      copiedMsg.style.opacity = '1';
      setTimeout(function() { copiedMsg.style.opacity = '0'; }, 2000);
    }
  }
}

if (!customElements.get('discount-popup')) {
  customElements.define('discount-popup', DiscountPopup);
}
